module.exports = __webpack_public_path__ + "img/z12.52457c06.jpg";